import React from "react";

const LedgerRow = ({ ledger }) => {
    const isActive = ledger.is_active !== false;

    const balance = Number(ledger.opening_balance || 0).toLocaleString(
        "en-IN",
        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    );

    return (
        <tr className="ledger-row">
            <td>
                <div className="ledger-name-cell">
                    <div className="ledger-icon">
                        {ledger.name?.charAt(0)?.toUpperCase() || "L"}
                    </div>

                    <div className="ledger-primary">
                        <strong>{ledger.name}</strong>

                        <span>
                            {ledger.code}

                            {ledger.is_system && <em className="system-label">System</em>}
                        </span>
                    </div>
                </div>
            </td>

            <td>
                <div className="ledger-group-cell">
                    <strong>{ledger.group_name || "—"}</strong>

                    {ledger.group_id && <span>Group #{ledger.group_id}</span>}
                </div>
            </td>

            <td>
                <span className="ledger-type">{ledger.ledger_type || "—"}</span>
            </td>

            <td>
                <span
                    className={
                        ledger.balance_nature?.toLowerCase() === "debit"
                        ? "balance-nature debit"
                        : "balance-nature credit"
                    }
                >
                    {ledger.balance_nature || "—"}
                </span>
            </td>

            <td>
                <span className="ledger-balance">₹{balance}</span>
            </td>

            <td>
                <span
                    className={isActive ? "status-pill active" : "status-pill inactive"}
                >
                    {isActive ? "Active" : "Inactive"}
                </span>
            </td>
        </tr>
    );
};

export default LedgerRow;
